export default __webpack_public_path__ + "static/media/main_nav_arrow_white.54c0afd1.svg";